export default __webpack_public_path__ + "static/media/bassam.17bfb096.png";